import BET_TYPES from './betTypes';

export const PAYOUTS = {
  [BET_TYPES.ANDAR]: 0.90,
  [BET_TYPES.BAHAR]: 1,
  [BET_TYPES.ONE_TO_FIVE]: 3,
  [BET_TYPES.SIX_TO_TEN]: 5,
  [BET_TYPES.ELEVEN_TO_FIFTEEN]: 6,
  [BET_TYPES.SIXTEEN_TO_TWENTYFIVE]: 5,
  [BET_TYPES.TWENTYSIX_TO_THIRTY]: 20,
  [BET_TYPES.THIRTYONE_TO_THIRTYFIVE]: 30,
  [BET_TYPES.THIRTYSIX_TO_FORTY]: 50,
  [BET_TYPES.FORTYONE_OR_MORE]: 100,
};

export const PAYOUT_FRACTION_FORMAT = 'fraction';
export const PAYOUT_MULTIPLIER_FORMAT = 'multiplier';
export const PAYOUT_DEFAULT_FORMAT = 'default';

export const PAYOUT_FRACTION_SEPARATOR = '/';
export const PAYOUT_MULTIPLIER_SEPARATOR = 'x';
export const PAYOUT_DEFAULT_SEPARATOR = ':';
